// Faq.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { InfiniteScroller, ScrollItem } from './InfiniteScroller.jsx';
import FaqArticle from '../container/FaqArticle.js';
import BackIcon from '../../img/ic_topbar_back.svg';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { color, headerHeight } from '../style/variables.js';

export class Faq extends React.PureComponent {
  state = { activeId: null };

  constructor(props) {
    super(props);
    // fetch data for SSR
    const {
      staticContext,
      language,
      fetchFaqArticles,
      fetchFaqArticlesFirstPageStatus,
    } = this.props;
    if (staticContext.actions) {
      if ('error' === fetchFaqArticlesFirstPageStatus.status) {
        staticContext.error = fetchFaqArticlesFirstPageStatus.error;
      }
      if (
        !['fetching', 'fetched'].includes(
          fetchFaqArticlesFirstPageStatus.status
        )
      ) {
        staticContext.actions.push({
          function: fetchFaqArticles,
          argumentObject: {
            page: 1,
            limit: 20,
            language,
            httpProxyHeaders: staticContext.httpProxyHeaders,
          },
        });
      }
    }
  }

  handleToggle = newId => {
    if (newId === null) {
      this.setState({ activeId: null });
    }
    this.setState({ activeId: newId });
  };

  componentDidMount() {
    const { language, articleIds, fetchFaqArticles } = this.props;
    if (!articleIds?.length) {
      this.nextTick = setTimeout(() => {
        fetchFaqArticles({ page: 1, language });
      });
    }
  }
  componentWillUnmount() {
    this.nextTick && clearTimeout(this.nextTick);
  }
  render() {
    const {
      t,
      goBack,
      language,
      articleIds,
      fetchFaqArticles,
      nextPage,
      isFetching,
    } = this.props;
    const { activeId } = this.state;
    return (
      <StyledFaq>
        <Header>
          <CloseButton role="button" onClick={goBack}>
            <CloseIcon src={BackIcon} title="close" />
          </CloseButton>
          <HeaderTitle>
            {t('seo_faq_h1', { ns: TranslationNamespace.SEO })}
          </HeaderTitle>
        </Header>
        <InfiniteScroller
          isFetching={isFetching}
          hasMore={nextPage !== null}
          useWindow={true}
          threshold={100}
          loadMore={() => fetchFaqArticles({ language, page: nextPage })}
        >
          <Container>
            <ScrollItem loader={<div />}>
              {articleIds.map(id => (
                <FaqArticle
                  key={id}
                  id={id}
                  language={language}
                  activeId={activeId}
                  onClick={this.handleToggle}
                />
              ))}
            </ScrollItem>
          </Container>
        </InfiniteScroller>
      </StyledFaq>
    );
  }
}

Faq.propTypes = {
  staticContext: PropTypes.object,
  goBack: PropTypes.func,
  t: PropTypes.func.isRequired,
  language: PropTypes.string,
  articleIds: PropTypes.array,
  nextPage: PropTypes.number,
  isFetching: PropTypes.bool,
  fetchFaqArticlesFirstPageStatus: PropTypes.object,
  fetchFaqArticles: PropTypes.func,
};

Faq.defaultProps = {
  staticContext: {},
  goBack: () => null,
  language: 'zh-TW',
  articleIds: [],
  nextPage: null,
  isFetching: null,
  fetchFaqArticlesFirstPageStatus: {},
  fetchFaqArticles: () => null,
};

const StyledFaq = styled.div`
  padding-top: calc(${headerHeight}px + var(--space-to-pinned-notification));
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  background-color: #191919;
`;

const Header = styled.div`
  position: fixed;
  top: var(--space-to-pinned-notification);
  left: 0px;
  right: 0px;
  z-index: 1;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  height: ${headerHeight}px;
  background-color: #232323;
`;

const CloseButton = styled.div`
  box-sizing: content-box;
  position: absolute;
  top: 0;
  left: 0;
  padding: 14px 16px;
  cursor: pointer;
  height: 30px;
  :hover {
    opacity: 0.7;
  }
`;

const CloseIcon = styled.img`
  height: 100%;
  width: auto;
  vertical-align: top;
`;

const HeaderTitle = styled.h1`
  flex: none;
  margin: 0px;
  font-size: 16px;
  color: ${color.white};
`;

const Container = styled.div`
  max-width: 768px;
  margin: 32px auto;
`;

export default withTranslation()(Faq);
